import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AccountDetails, UpdateAccountDetailsRequest } from '../models/account-detail-request.model';
import { Subject, takeUntil } from 'rxjs';
import { CloudProfileService } from '../services/cloud-profile.service';
import { faCog, faSave } from '@fortawesome/free-solid-svg-icons';
import { RegistrationFormComponent } from '../authentication/components/registration-form/registration-form.component';
import { CloudNotificationService } from '../services/cloud-notification.service';
import { CloudNotificationStyle } from '../models/cloud-notification-style.model';
import { CloudSubscriptionService } from '../cloud-subscription/services/cloud-subscription.service';
import Helper from '../Util/helper';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.sass']
})

export class AccountDetailComponent implements OnInit, OnDestroy {

  @ViewChild('detailsForm') detailsForm: RegistrationFormComponent;

  private unsubscribe$ = new Subject<void>();

  faCog = faCog;
  faSave = faSave;

  isLoadingSubscriptions: boolean = true;
  isLoadingAccountDetails: boolean = false;
  isSubmittingDetails: boolean = false;

  userHasSubscription: boolean;
  accountDetails: AccountDetails;
  detailsSubmitted = false;
  controlsChanged = false;

  constructor(
    private readonly router: Router,
    private profileSvc: CloudProfileService,
    private cloudSubscriptionService: CloudSubscriptionService,
    private notificationSvc: CloudNotificationService) { }

  ngOnInit(): void {
    this.isUserSubscriptionExists();
    this.getAccountDetails();
  }

  hasMadeChangesToForm(status: boolean) {
    this.controlsChanged = status;
  }

  isUserSubscriptionExists(): void {

    this.cloudSubscriptionService.userHasSubscription().pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (subscriptionExists) => {

        this.userHasSubscription = subscriptionExists

        if (!this.userHasSubscription) {
          this.navigateToDashboard()
        }

        this.isLoadingSubscriptions = false;
      },

      error: (err: HttpErrorResponse) => {
        this.userHasSubscription = false
        this.isLoadingSubscriptions = false
        this.notificationSvc.createToastNotification('user-subscription-exists', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger);
      }
    })

  }

  getAccountDetails(): void {

    this.isLoadingAccountDetails = true

    this.profileSvc.getAccountDetail().pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (accDetails) => {
        this.accountDetails = accDetails
        this.isLoadingAccountDetails = false
      },

      error: (err: HttpErrorResponse) => {
        this.userHasSubscription = false
        this.isLoadingAccountDetails = false
        this.notificationSvc.createToastNotification('get-account-details', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger);
      }
    })

  }

  saveDetails() {
    this.detailsForm.onSubmit();
  }

  updateUser(obj: any) {

    this.isSubmittingDetails = true;

    const req = new UpdateAccountDetailsRequest();
    req.primaryUser = obj.primaryUser;
    req.companyDetails = obj.company;
    req.secondaryUser = obj.secondaryUser;

    this.profileSvc.changeUserName(req.primaryUser.firstName);
    this.profileSvc.changeCompanyName(req.companyDetails.name);
    this.profileSvc.updateUserName(req.primaryUser.firstName)

    this.profileSvc.updateAccountDetail(req).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (isUpdated) => {

        if (isUpdated) {
          this.notificationSvc.createToastNotification('update-account', 'Profile Updated', CloudNotificationStyle.success);
          this.isSubmittingDetails = false;

        } else {
          this.notificationSvc.createToastNotification('update-account', 'Could not update account information', CloudNotificationStyle.danger);
        }

        this.getAccountDetails();
      },

      error: (error) => {
        this.isSubmittingDetails = false;
        this.notificationSvc.createToastNotification('update-account', 'Error: ' + Helper.resolveErrorMessage(error), CloudNotificationStyle.danger);
      }

    })

  }

  navigateToDashboard() {
    this.router.navigate([environment.routes.subscription]);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

}


